import script from "./userProfileMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./userProfileMenu.vue?vue&type=script&setup=true&lang=ts"

import "./userProfileMenu.vue?vue&type=style&index=0&id=129e53d5&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-129e53d5"]])

export default __exports__
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSeparator,QIcon});
